import { getPref, Prefs, setPref } from '~/common/prefs';

/** Whether this user has already acted on the "Reports have moved" notice in this browser. */
export function hasSeenReportsMoved(userId: string | undefined): boolean {
  if (!userId) return false;
  return getPref(Prefs.REPORTS_MOVED_SEEN, userId) === 'true';
}

/** Remembers that this user found where reports moved, so the left nav can drop its Reports item. */
export function markReportsMovedSeen(userId: string | undefined): void {
  if (userId) setPref(Prefs.REPORTS_MOVED_SEEN, 'true', userId);
}
